export default __webpack_public_path__ + "static/media/edit.6af0044a.svg";